import React from "react";
import { useSelector } from "react-redux";
import {
  BodyField,
  CheckTerm,
  FirstName,
  FirstNameKana,
  LastName,
  LastNameKana,
  LoginConfirmField,
  LoginField,
  Phone,
} from "../field-input";

const FormContact = ({
  register,
  handleSubmit,
  onSubmit,
  onError,
  clearErrors,
  setError,
  errors,
  watch,
  info,
}) => {
  const { cms, isInLine } = useSelector((state) => state.contact);

  return (
    <form className="px-3 px-lg-0" onSubmit={handleSubmit(onSubmit, onError)}>
      {
        !isInLine &&
          <div>
            <input type="hidden" name={"type"} value={0} {...register("type")} />
            <div className="border-form-hidden border-color-black border-radius-5">
              <div className="p-15 py-4">
                <div className="form-group">
                  <label className="mb-2">
                    お名前<span>[必須]</span>
                  </label>
                  <div className="row gx-2">
                    <div className="col-12 col-md-4">
                      <FirstName info={info} register={register} errors={errors} />
                    </div>
                    <div className="col-12 col-md-4 mt-2 mt-md-0">
                      <LastName info={info} register={register} errors={errors} />
                    </div>
                  </div>
                </div>
                <div className="form-group py-2 py-md-1">
                  <label className="mb-2">
                    お名前(カナ)<span>[必須]</span>
                  </label>
                  <div className="row gx-2">
                    <div className="col-12 col-md-4">
                      <FirstNameKana
                        info={info}
                        register={register}
                        errors={errors}
                      />
                    </div>
                    <div className="col-12 col-md-4 mt-2 mt-md-0">
                      <LastNameKana info={info} register={register} errors={errors} />
                    </div>
                  </div>
                </div>

                <div className="form-group py-2 py-md-1">
                  <label className="mb-2">
                    メールアドレス
                    <span>[必須]</span>
                    <span>半角英数字</span>
                  </label>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <LoginField
                        info={info}
                        register={register}
                        errors={errors}
                        clearErrors={clearErrors}
                        setError={setError}
                        watch={watch}
                      />
                    </div>
                  </div>
                  <label className="sub-label sp-none">
                    確認のため、再度入力してください。
                  </label>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <LoginConfirmField
                        info={info}
                        register={register}
                        errors={errors}
                        watch={watch}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group py-2 py-md-1">
                  <label className="mb-2">
                    電話番号<span className="grey">[必須]</span>
                    <span>半角数字・ハイフンなし</span>
                  </label>
                  <div className="row">
                    <div className="col-12">
                      <Phone info={info} register={register} errors={errors} />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label className="mb-2">
                    お問い合わせ内容<span>[必須]</span>
                  </label>
                  <div className="row">
                    <div className="col-12">
                      <BodyField info={info} register={register} errors={errors} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="px-0 p-15 pb-4">
                <div className="confirm-form auth mt-4">
                  <div className="header bg-confirm-request">
                    <div className="title fs-16 mt-2 mt-md-0">個人情報の取扱い</div>
                    <div className="sub-title">▼最後までスクロールしてください</div>
                  </div>
                  <div
                    className="html-design-table form-scroll border-bottom p-3"
                    dangerouslySetInnerHTML={{ __html: cms?.terms1 }}
                  ></div>

                  <CheckTerm register={register} errors={errors} info={info} />
                </div>
              </div>
            </div>

            {/* <!-- GROUP BUTTON --> */}
            <div className="group-btn-custom my-4 my-md-5">
              <div onClick={() => history.go(-1)} className="btn-custom after">
                キャンセル
              </div>
              <input
                type="submit"
                value="入力内容を確認する"
                className="btn-custom red-light before"
              />
            </div>
          </div>
      }
    </form>
  );
};

export default FormContact;
